import { render, staticRenderFns } from "./IntersectionObserved.vue?vue&type=template&id=5120a354"
import script from "./IntersectionObserved.vue?vue&type=script&lang=ts"
export * from "./IntersectionObserved.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports